import React from 'react';

const SignupHeader = (): JSX.Element => {
  return (
    <div id='signup-header-container'>
      <div id='signup-header'>
        <span className='icon-default-logo header-icon-logo' />
      </div>
    </div>
  );
};

export default SignupHeader;
